/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react'
import { FooterContainer, FooterLinkSection } from './styles'
import { Header2, Header3, Text } from '../../styles/Components'
import Link from 'next/link'
import { serviceUrls, supportUrls, aboutUrls } from './url-data'
import {
  InstagramIcon, FacebookIcon, TikTokIcon, LinkedInIcon, YouTubeIcon,
  // CrunchbaseIcon, TrustpilotIcon
} from './social-icons'
import { useRouter } from 'next/router'
import styled from '@emotion/styled'
import Image from 'next/image'

const AppStoreContainer = styled.div`
  position: relative;
  height: 46px;
  margin-top: 30px;
`

const Footer = ({ forceShow = false }) => {
  const appUrl = 'https://apps.apple.com/us/app/glamsquad/id766676007?ign-mpt=uo%3D4'
  const socialLinks = {
    instagram: 'https://www.instagram.com/glamsquad/',
    facebook: 'https://www.facebook.com/GlamSquad/',
    tiktok : 'https://www.tiktok.com/@glamsquad',
    linkedin: 'https://www.linkedin.com/company/glamsquad',
    youtube: 'https://www.youtube.com/@_glamsquad',
    // removing until these are improved
    // crunchbase: 'https://www.crunchbase.com/organization/glamsquad',
    // trustpilot: 'https://www.trustpilot.com/review/glamsquad.com'
  }

  const { pathname } = useRouter()

  if (
    (!forceShow && pathname.includes('book')) ||
    pathname.includes('printable') ||
    pathname.includes('appointment-survey')
  ) {
    return null
  }

  return (
    <FooterContainer>
      <div className='footer-top'>
        <div className='app-section app-install-prompt'>
          <div className='left-header'>
            <Header2>Book your glam on the go</Header2>
            <Text variant='medium'>Download the Glamsquad app</Text>
          </div>

          <AppStoreContainer>
            <a href={appUrl}>
              <Image
                src='/images/download_on_app_store.svg'
                alt='Download the GLAMSQUAD app on the Apple App Store'
                width='130'
                height='46'
              />
            </a>
          </AppStoreContainer>
        </div>

        <div className='footer-right'>
          <div className='link-sections'>
            <div className='sections-container'>
              <FooterSection 
                title='Shop'
                sections={serviceUrls}
              />
              <FooterSection 
                title='About'
                sections={aboutUrls}
              />
              <FooterSection 
                title='Support'
                sections={supportUrls}
              />
            </div>
          </div>
          <div className='footer-social'>
            <div><a href={socialLinks.instagram}><InstagramIcon/></a></div>
            <div><a href={socialLinks.facebook}><FacebookIcon /></a></div>
            <div><a href={socialLinks.tiktok}><TikTokIcon /></a></div>
            <div><a href={socialLinks.linkedin}><LinkedInIcon /></a></div>
            <div><a href={socialLinks.youtube} aria-label='Glamsquad on YouTube'><YouTubeIcon /></a></div>
            {/* disabled until we update */}
            {/* <div><a href={socialLinks.crunchbase} aria-label='Glamsquad on Crunchbase'><CrunchbaseIcon /></a></div>
            <div><a href={socialLinks.trustpilot} aria-label='Glamsquad reviews on Trustpilot'><TrustpilotIcon /></a></div>*/}
          </div>
        </div>
      </div>

      <div className='footer-bottom-logo'>
        <img src='/images/new-gs-wordmark-logo.svg' width='358' height='49.219' alt='glamsquad logo' />
      </div>
    </FooterContainer>
  )
}

const FooterSection = ({ title, sections }) => {
  const [ open, setOpen ] = useState(false)

  const toggle = () => {
    setOpen(s => !s)
  }

  return (
    <FooterLinkSection>
      <div onClick={toggle} className='section-header-wrapper'>
        <Header3>{title}</Header3>
        <button style={{ color: '#000' }}>{!open ? '+' : '-'}</button>
      </div>

      <ul className={`${open ? '' : 'hidden'}`}>
        { sections.map(section => (
          <li key={section.name}>
            { section.link && (
              <Link href={section.link}><Text>{section.name}</Text></Link>
            )}

            { section.href && (
              <Link legacyBehavior href={section.href}><a target='_blank'><Text>{section.name}</Text></a></Link>
            )}
          </li>
        ))}
      </ul>
    </FooterLinkSection>
  )
}

export default Footer
